import React from 'react';

const SpinnerClassic = (props) => {
  let inlineSmall = false;
  if (props.inlineSmall === true) {
    inlineSmall = true;
  }
  return (
    <div className={"spinner-classic" + (inlineSmall ? " spinner-classic--inline-small" : "")}>
      <div className="spinner-classic__rotating-fig"></div>
    </div>
  );
};

export default SpinnerClassic;